import triggerTrackingPixel from '@paperstac/common/lib/services/triggerTrackingPixel';

export const fireRegisterEvent = () =>
  triggerTrackingPixel('https://dc.ads.linkedin.com/collect/?pid=532076&conversionId=664073&fmt=gif');
